<template>
  <div class="list-wrap">
    <el-card class="list-body">
     <!--  <el-row class="mb10">
        <el-select @change="onChangeListType" size="small" style="width:320px" v-model="listType">
          <el-option :key="index" :label="item.text" :value="item.value" v-for="(item,index) in options.listType"></el-option>
        </el-select>
      </el-row> -->
      <!-- 筛选区域 -->
      <el-form :inline="true" :model="search" ref="searchForm" size="mini">
        <el-form-item label="筛选"></el-form-item>
        <el-form-item>
          <el-select @change="onChangeListType" style="width:300px" v-model="listType">
            <el-option :key="index" :label="item.text" :value="item.value" v-for="(item,index) in options.listType"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :rules="[{ min:11,max:11, message: '请填写11位的溯源码',trigger: 'blur'}]"
          prop="unActive.traceable_code"
          v-if="listType==1"
        >
          <el-input class="select-input" placeholder="溯源码" size="mini" v-model="search.unActive.traceable_code"></el-input>
        </el-form-item>
        <el-form-item v-if="listType==3">
          <el-input class="select-input" placeholder="店铺id" size="mini" v-model="search.todo.todo"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="select-input" placeholder="用户id" size="mini" v-model="search.common.ac_id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select placeholder="状态" v-model="search.common.status">
            <el-option :value="null" label="全部"></el-option>
            <el-option :value="1" label="待处理"></el-option>
            <el-option :value="2" label="已处理"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSearch" size="mini" type="primary">筛选</el-button>
          <el-button @click="onReset" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格区域 -->
      <!-- 表格1 -->
      <el-table
        :data="dataList"
        class="page-wrap"
        header-row-class-name="table-black-header"
        key="listTable1"
        ref="listTable1"
        style="width: 100%"
        v-if="listType==1"
      >
        <el-table-column label="积分码" min-width="120" prop="security_code"></el-table-column>
        <el-table-column label="溯源码" min-width="120" prop="traceable_code">
          <template slot-scope="scope">
            <span @click="toCodeDetail(scope.row.traceable_code)" class="underline cursor">{{scope.row.traceable_code}}</span>
          </template>
        </el-table-column>
        <el-table-column label="异常类型" prop="error_type">
          <!-- 2=未激活 3=不存在 4=已作废 -->
          <template slot-scope="scope">
            <span v-if="scope.row.error_type == 2">未激活</span>
            <span v-else-if="scope.row.error_type == 3">不存在</span>
            <span v-else-if="scope.row.error_type == 4">已作废</span>
          </template>
        </el-table-column>
        <el-table-column label="用户id" prop="ac_id">
          <template slot-scope="scope">
            <span @click="toUserDetail(scope.row.ac_id)" class="underline cursor">{{scope.row.ac_id}}</span>
          </template>
        </el-table-column>
        <el-table-column label="查询时间" prop="queried_at"></el-table-column>
        <el-table-column label="备注" prop="note"></el-table-column>
        <el-table-column label="状态">
          <!-- 1=待处理 2=已处理 -->
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">待处理</span>
            <span v-else-if="scope.row.status == 2">已处理</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="showRemark(scope.row.id,'unactivated')"
              size="mini"
              type="text"
            >{{scope.row.status==1?'处理':'备注'}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 表格2 -->
      <el-table
        :data="dataList"
        class="page-wrap"
        header-row-class-name="table-black-header"
        key="listTable2"
        ref="listTable2"
        style="width: 100%"
        v-else-if="listType==2"
      >
        <el-table-column label="用户id" prop="ac_id">
          <template slot-scope="scope">
            <span @click="toUserDetail(scope.row.ac_id)" class="underline cursor">{{scope.row.ac_id}}</span>
          </template>
        </el-table-column>
        <el-table-column label="异常类型">
          <template>{{options.listType[1].text}}</template>
        </el-table-column>
        <el-table-column label="时间" prop="queried_at"></el-table-column>
        <el-table-column label="备注" prop="note"></el-table-column>
        <el-table-column label="状态">
          <!-- 1=待处理 2=已处理 -->
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">待处理</span>
            <span v-else-if="scope.row.status == 2">已处理</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="showRemark(scope.row.id,'toplimit')"
              size="mini"
              type="text"
            >{{scope.row.status==1?'处理':'备注'}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 表格3 -->
      <el-table
        :data="dataList"
        class="page-wrap"
        header-row-class-name="table-black-header"
        key="listTable3"
        ref="listTable3"
        style="width: 100%"
        v-else-if="listType==3"
      >
        <el-table-column label="店铺id" prop="ac_id">
          <template slot-scope="scope">
            <span @click="toUserDetail(scope.row.ac_id)" class="underline cursor">{{scope.row.ac_id}}</span>
          </template>
        </el-table-column>
        <el-table-column label="异常类型">
          <template>{{options.listType[2].text}}</template>
        </el-table-column>
        <el-table-column label="异常用户" prop="queried_at"></el-table-column>
        <el-table-column label="备注" prop="note"></el-table-column>
        <el-table-column label="状态">
          <!-- 1=待处理 2=已处理 -->
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">待处理</span>
            <span v-else-if="scope.row.status == 2">已处理</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="showRemark(scope.row.id)" size="mini" type="text">{{scope.row.status==1?'处理':'备注'}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--页码信息-->
      <div class="ftc mt10">
        <el-pagination
          :page-size="page.pageSize"
          :total="page.total"
          @current-change="onChangePage"
          background
          layout="total, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </el-card>
    <!-- 备注 -->
    <el-dialog :visible.sync="remark.show" title="备注" width="500px">
      <el-form :model="remark" label-width="80px" ref="remarkForm">
        <el-form-item :rules="{required: true, message: '请填写备注内容'}" label="备注内容" prop="note">
          <el-input type="textarea" v-model="remark.note"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer ftc" slot="footer">
        <el-button @click="onRemark" type="primary">确认</el-button>
        <el-button @click="remark.show = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { abnormalApi } from '@/api/abnormal'
import lodash from 'lodash'
const tempSearch = {
  common: {
    ac_id: '', //	int	用户ID	筛选条件
    status: undefined, //	否	int	状态	筛选条件
  },
  unActive: {
    traceable_code: '', //	string	溯源码	筛选条件
  },
  limit: {},
  todo: {
    todo: '',
  },
}
export default {
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 50,
        total: 0,
      },

      search: lodash.cloneDeep(tempSearch),
      options: {
        listType: [
          {
            value: '1',
            text: '未激活被查询',
          },
          {
            value: '2',
            text: '一天查询不同防伪码达到20次',
          },
          // {
          //   value: '3',
          //   text: '一个店铺的贴纸，超过20%被某个用户获取',
          // },
        ],
      },
      listType: '1', // 默认未激活列表
      dataList: [],
      remark: {
        id: '',
        note: '',
        show: false,
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    /**
     * 获取贴纸列表
     */
    getList(page = 1) {
      switch (this.listType) {
        case '1':
          return this.getUnActiveList(page)
        case '2':
          return this.getLimitList(page)
        case '3':
          return this.getUnActiveList(page)
      }
    },
    /**
     * 异常列表（未激活被查询）
     */
    getUnActiveList(page) {
      const params = {
        page,
        per_page: this.page.pageSize,
        ...this.search.common,
        ...this.search.unActive,
      }
      return this.$EpetJs.Common.get(abnormalApi.getUnActiveList, params, {
        needLoading: true,
      }).then((res) => {
        if (res) {
          this.dataList = res.data.data
          if (res.data.meta && res.data.meta.pagination) {
            this.page.total = res.data.meta.pagination.total
            this.page.currentPage = res.data.meta.pagination.current_page
          }
        }
        return res
      })
    },
    /**
     * 异常列表（一天查询防伪码达到上限）
     */
    getLimitList(page) {
      const params = {
        page,
        per_page: this.page.pageSize,
        ...this.search.common,
        ...this.search.limit,
      }
      return this.$EpetJs.Common.get(abnormalApi.getLimitList, params, {
        needLoading: true,
      }).then((res) => {
        if (res) {
          this.dataList = res.data.data
          if (res.data.meta && res.data.meta.pagination) {
            this.page.total = res.data.meta.pagination.total
            this.page.currentPage = res.data.meta.pagination.current_page
          }
        }
        return res
      })
    },
    /**跳转用户详情 */
    toUserDetail(ac_id) {
      this.$router.push({
        path: '/client_user/detail/'+ac_id
      })
    },
    /**跳转贴纸详情 */
    toCodeDetail(id) {
      this.$router.push('/sticker/detail/' + id)
    },
    /**
     * remark dialog
     */
    showRemark(id, type) {
      this.remark = {
        id,
        type,
        show: true,
        note: '',
      }
      this.$nextTick(() => {
        this.$refs['remarkForm'].clearValidate()
      })
    },
    /**
     * 提交备注
     */
    onRemark() {
      return this.$refs['remarkForm'].validate(async (valid) => {
        if (!valid) return
        const params = {
          type: this.remark.type,
          note: this.remark.note,
        }
        await this.$EpetJs.Common.patch(abnormalApi.addRemark + this.remark.id, params, {
          needLoading: true,
        }).then((res) => {
          if (res) {
            this.dataList = res.data.data
            if (res.data.meta && res.data.meta.pagination) {
              this.page.total = res.data.meta.pagination.total
            }
          }
          return res
        })
        await this.getList(this.page.currentPage)
        this.remark.show = false
      })
    },
    // 改变列表类型
    onChangeListType() {
      this.getList()
    },
    /**
     * 当前页改变
     */
    onChangePage(val) {
      this.getList(val)
    },
    /**
     * 筛选
     */
    onSearch() {
      this.$refs['searchForm'].validate((valid) => {
        if (!valid) return
        this.getList()
      })
    },
    /**
     * 重置
     */
    onReset() {
      this.search = lodash.cloneDeep(tempSearch)
      this.getList()
    },
  },
}
</script>
<style lang="less">
.select-input {
  width: 160px;
}
.list-wrap {
  .list-body {
    min-height: calc(100vh - 60px);
    .delete-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }
    .detail-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }
  }
}
</style>